import React from 'react';
import Configurator from './Configurator.jsx';
import styles from './PatchcordConfigurator.styl';

/**
 * Конфигуратор патч-кордов
 */
class PatchcordConfigurator extends Configurator
{
	constructor(props) {
		super(props);
		this.onSwitchConfigurator = this.onSwitchConfigurator.bind(this);
	}

	getType() {
		return 'patchcord';
	}
	// из-за того что на itk сервере старый php переводим временно конфигуратор на iek сервер
	// после того как на itk сервере обновят php, просто убрать этот метод и будет работать родительский getApiUrl()
	getApiUrl() {
		return 'https://cfg.iek.ru/api/iek-proxy/products/configurators/iekcfg/itkcfg.php';
	}

	onSwitchConfigurator() {
		if (this.props.onSwitchConfigurator) {
			this.props.onSwitchConfigurator();
		}
	}

	getCustomElements() {
		let elements = [];

		elements.push(
			<label className={styles.confTypePatchcord} key="patchcord">
				<span className={styles.confTypeTitle}>Патч-корд</span>
				<input className={styles.confTypeControl} name="itkcfg_filter_conf_type" type="radio" defaultChecked={true} />
			</label>
		);

		elements.push(
			<label className={styles.confTypePigtail} key="pigtail">
				<span className={styles.confTypeTitle}>Пигтейл</span>
				<input className={styles.confTypeControl} name="itkcfg_filter_conf_type" type="radio" defaultChecked={false} onChange={this.onSwitchConfigurator} />
			</label>
		);

		return elements;
	}

	getCustomStyles() {
		return styles;
	}
}

export default PatchcordConfigurator;



// WEBPACK FOOTER //
// ./src/react/PatchcordConfigurator.jsx